import axios from 'axios'
import Store from '@/store'

//export const SANCTUM_CSRF_EDNPOINT = 'http://localhost:8002/sanctum/csrf-cookie'
//export const API_ENDPOINT = 'http://localhost:8002/api/'

//export const SANCTUM_CSRF_EDNPOINT = 'http://localhost:8002/sanctum/csrf-cookie'
//export const API_ENDPOINT = 'http://super-duke.test/api/'

export const SANCTUM_CSRF_EDNPOINT = 'https://cloud.palisada-sistemi.si/sanctum/csrf-cookie'
export const API_ENDPOINT = 'https://cloud.conforma.si/public/api/'

//window.console.log("VUE_APP_AUTH: " + process.env.VUE_APP_AUTH);
export function get(url) {
    return axios({
        method: 'GET',
        url: url,
        headers: {
            'Authorization': `Bearer ${Store.state.user.access_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function post(url, payload) {
    return axios({
    	method: 'POST',
    	url: url,
    	data: payload,
    	headers: {
            'Authorization': `Bearer ${Store.state.user.access_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function put(url, payload) {
    return axios({
        method: 'POST',
        url: url,
        data: payload,
        headers: {
            'Authorization': `Bearer ${Store.state.user.access_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function destroy(url) {
    return axios({
        method: 'POST',
        url: url,
        headers: {
            'Authorization': `Bearer ${Store.state.user.access_token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
    	}
    })
}

export function download(url) {
    return axios({
        method: 'GET',
        url: url,
        responseType: 'blob', // important
        headers: {
            'Authorization': `Bearer ${Store.state.user.access_token}`
    	}
    })
}

export function interceptors(cb) {
    axios.interceptors.response.use((res) => {
        return res;
    }, (err) => {
        cb(err)
        return Promise.reject(err)
    })
}